module.exports = __webpack_public_path__ + "media/brochure.2335f393.pdf";